$(function(){
    function objDrawPreloader(settings,imgName,width){

        this.width=width;
        this.imgName=imgName;
        var width2=Math.round(this.width/2);
        this.start=[Math.round(settings.width/2-width/2),Math.round(settings.height/2-width/2)];
        this.pathArr=[
            [width2,0],
            [this.width,width2],
            [width2,this.width],
            [0,width2],
            [width2,0],
        ];
        this.pathReal=new Smooth(this.pathArr);
        this.step=0;
    }
    objDrawPreloader.prototype={
        next:function(ctx,img){
            this.step=(this.step+5)%100;
            var a=1,b=0.2;
            var step=this.step*a+this.step*this.step*b;
            var step_max=a*100+b*100*100;
            var i=0;
            for(i=0;i<4;i++){
                var tmp=this.pathReal(step/step_max+i);
                drawImage(ctx,img,tmp[0]+this.start[0],tmp[1]+this.start[1],80);
            }
//            $.qLog(this.step+" ");
            return 1;
            
//            drawImage(ctx,img,x,y);
        }
    };
    
    
    function quickAnim(imgName,clips,pos_arr,two_side){
        if(typeof pos_arr=="undefined"){
            pos_arr[0,0];
        }
        this.imgName=imgName;
        this.step=0;
        this.two_side=intval(two_side);
        this.step_max=clips-1;
        this.dir=1;
        this.pos_arr=copyArray(pos_arr);
    }
    quickAnim.prototype={
        next:function(ctx,img){
            
            
            this.step+=this.dir;
            //[0,1,2,3,4,5] clips 6
            if(this.two_side){
                if(this.step>=this.step_max){
                    this.dir=-1;
                    this.step=this.step_max;
                }
                if(this.step<=0){
                    this.step=0;
                    this.dir=1;
                }
                
                
            }
            else{
                if(this.step>this.step_max){
                    this.step=0;
                }
            }
            
            var height=img.height;
            var width=img.width/(this.step_max+1);
            drawImageCrop(ctx,img,this.pos[0],this.pos[1],-width*this.step,0,width,height);
            
//            $.qLog(this.step+" ");
            return 1;
            
//            drawImage(ctx,img,x,y);
        }
    };
    
    
        
    var _animObj={};
    $.fn.myAnimTiny=function(options,timeHandler,timeIndex){
        
        var th=$(this);
        var settings=th.data("myAnimTiny");
        var methods={
            "prepareLoader":function(imgName,width){
                settings.animIndex=getNewObjectIndex(_animObj,new objDrawPreloader(copyObj(settings),imgName,width));
            },
        };
        
        function drawScene(){
            ctx.clearRect(0, 0, settings.width, settings.height);
            if(settings.animIndex!=-1 && typeof _animObj[settings.animIndex]!="undefined"){
                _animObj[settings.animIndex].next(ctx,imageAll[_animObj[settings.animIndex].imgName]);
            }
        }
        
        function prepareImages(){
            var i;
            for(i in settings.load_images){
                imageAll[i]=new Image();
                imageAll[i].src=settings.load_images[i];
            }
        }
        if(typeof options=="object"){
            var imageAll={};
            var ctx=th[0];
            
            settings=$.extend( {
                period:40,
                load_images:{
                    "heart":""+_IMG_SERV+"/gfx/place/girls/anim/heart.png",
                },
                width:0,
                height:0,
                animIndex:-1
            }, options);
            if(settings.width==0){
                settings.width=th.width();
                settings.height=th.height();
            }
            
           
            ctx=ctx.getContext("2d");
            $("<div/>").one("myload",function(){
                prepareImages();
                timeHandler.clear(timeIndex);
                timeHandler.set(timeIndex,function(){
                    drawScene();
                },settings.period,function(){
                    if(settings.animIndex!=-1){
                        delete _animObj[settings.animIndex];
                    }
                });
                th.trigger("was_loaded");
            }).myLoad(settings.load_images);
            
        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            if(typeof methods[options]!="undefined"){
                methods[options].apply(this,arg);
            }
        }
        th.data("myAnimTiny",settings);
        
        
        
        
        
        return th;
    };
    
});


